// @flow
import * as React from 'react';
import { Divider, Stack, Typography } from '@mui/material';
import { SelectedPlansList } from '@coverright/widgets';
import { useClient } from '../../hooks/client-context';
import { useEffect, useState } from 'react';
import { environment } from '../../../../../environments/environment';
import { ApolloProvider } from '@apollo/client';
import { mainBackendApolloClient } from '@coverright/data-access/apollo-clients';
import { NoData } from '../../../../shared';


export const SelectedPlans = () => {
  const client = useClient();
  const [state, setState] = useState<any>({});

  useEffect(() => {
    if (client?.quoteId) {
      fetch(
        `${environment.userFlowRestUrl}/getState/${client.quoteId}`
      ).then((data) => {
        if (data.status === 200) {
          return data.json();
        }
        return {state: {}}
      }).then(data => setState(data?.state || {}))
    }
  }, [client?.quoteId]);

  if (!client?.quoteId) {
    return null;
  }

  const hasPlans = state?.mgSavedPlans?.length || state?.maSavedPlans?.length || state?.pdpSavedPlans?.length;

  return (
    <ApolloProvider client={mainBackendApolloClient}>
      <Stack gap={2} sx={{'& button': {display: 'none'}, '& p': {fontSize: 14} }}>
        <Divider />
        <Typography variant="subtitle1">Selected plans</Typography>

        {!hasPlans && <NoData height={100} />}
        <SelectedPlansList quoteId={client.quoteId}
                           clientId={client.id}
                           appContext={[
                             state,
                             () => {},
                             true
                           ]} />
      </Stack>
    </ApolloProvider>
  );
};
